interface WaveDividerProps {
  color?: "pink" | "purple" | "teal" | "yellow" | "orange" | "primary";
  flip?: boolean;
}

const WaveDivider = ({ color = "primary", flip = false }: WaveDividerProps) => {
  const colorClasses = {
    pink: "fill-[hsl(340,82%,76%)]",
    purple: "fill-[hsl(270,67%,72%)]",
    teal: "fill-[hsl(174,72%,56%)]",
    yellow: "fill-[hsl(45,93%,58%)]",
    orange: "fill-[hsl(25,95%,63%)]",
    primary: "fill-primary/20",
  };

  return (
    <div className={`w-full overflow-hidden leading-none ${flip ? "rotate-180" : ""}`}>
      <svg
        className={`relative block w-full h-12 md:h-16 ${colorClasses[color]}`}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1200 120"
        preserveAspectRatio="none"
      >
        <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z" />
      </svg>
    </div>
  );
};

export default WaveDivider;
